// @ts-nocheck
"use client";

import { useEffect } from "react";

import { SiteEntityGraph } from "./JsonLd";
import Footer from "./sections/Footer";
import Navbar from "./sections/Navbar";
import Overlays from "./sections/Overlays";

// `noindex` pages (status, share links, noindexed legal pages) pass noindex so
// they don't re-emit the site-level Organization/WebSite entities (policy §9.11).
export default function PageShell({
  children,
  noindex = false,
}: {
  children: React.ReactNode;
  noindex?: boolean;
}) {
  useEffect(() => {
    document.body.classList.add("ready");

    // ── Reveal observer for .rev elements ──
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("vis");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.07, rootMargin: "0px 0px -28px 0px" });

    // Reveal all `.rev` elements immediately. Works for: first load,
    // browser-back (scroll restored mid-page), bfcache restore, and prod
    // builds where any timing race would otherwise leave content invisible.
    // The intersection observer is no longer needed for one-shot reveals
    // since SSR already places content in the DOM — keeping it would only
    // delay above-the-fold visibility.
    const revealAll = () => {
      document.querySelectorAll(".rev").forEach((el) => el.classList.add("vis"));
    };

    // Reveal synchronously on mount.
    revealAll();
    // Also schedule a follow-up reveal in case any `.rev` elements were
    // appended after mount (rare, but cheap insurance).
    const revTimer = setTimeout(revealAll, 100);
    // Disconnect the observer immediately — we don't need it now.
    io.disconnect();

    // ── Nav scroll state ──
    const nav = document.getElementById("nav");
    const spf = document.getElementById("spf");
    const onScroll = () => {
      if (nav) nav.classList.toggle("scrolled", scrollY > 20);
      if (spf) {
        const total = document.body.scrollHeight - innerHeight;
        if (total > 0) spf.style.width = (scrollY / total * 100) + "%";
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      clearTimeout(revTimer);
      io.disconnect();
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <>
      {!noindex && <SiteEntityGraph />}
      <Overlays />
      <Navbar />
      <main id="main" style={{ paddingTop: "62px" }}>{children}</main>
      <Footer />
    </>
  );
}
